import { EditTabWidgetProps } from "processhub-components-lib/dist/lib/types/dashboard";
import { EditConfirmationButtons } from "./EditConfirmationButtons";
import React from "react";


export const EditTabWidget: React.FC<EditTabWidgetProps> = ({ tabError, tabMode, setScreen, setNewTab, setTabError, submit, children }) => {
    return (
        <div className="h-full flex items-center justify-center">
            <div>
                {children}
                <EditConfirmationButtons
                    tabError={tabError}
                    tabMode={tabMode}
                    setScreen={setScreen}
                    setNewTab={setNewTab}
                    setTabError={setTabError}
                    submit={submit}
                />
            </div>
        </div>
    );
};